import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import {
  mapTimeOffPolicyToUpdateRequest,
  mapTimeOffTypeDetailsFromResponse,
  mapTimeOffTypeListFromResponse,
} from '../mappers/time-off-type.mapper';
import { TimeOffPolicyResponse } from '../types/dto/response/time-off-policy-response';
import {
  TimeOffTypeListItemResponse,
  TimeOffTypeResponse,
} from '../types/dto/response/time-off-type-response';
import { TimeOffTypeDetails, TimeOffTypeListItem } from '../types/time-off';
import { TimeOffTypeSetupFormData } from '../validations/time-off-type-validation';

export const getTimeOffTypes = async (): Promise<TimeOffTypeListItem[]> => {
  const endpoint = '/api/time-off/settings/types';

  const response = await withApiErrorHandler(
    endpoint,
    ApiErrorCode.TIME_OFF_TYPES_LOAD_FAILED,
    () => axiosInstance.get<ApiResponse<TimeOffTypeListItemResponse[]>>(endpoint)
  );

  return mapTimeOffTypeListFromResponse(response);
};

export const getTimeOffTypeById = async (id: number): Promise<TimeOffTypeDetails | null> => {
  const endpoint = `/api/time-off/settings/types/${id}`;

  const response = await withApiErrorHandler(
    endpoint,
    ApiErrorCode.TIME_OFF_TYPE_DETAILS_LOAD_FAILED,
    () => axiosInstance.get<ApiResponse<TimeOffTypeResponse>>(endpoint)
  );

  return mapTimeOffTypeDetailsFromResponse(response);
};

export interface UpdateTimeOffTypePayload {
  data: TimeOffTypeSetupFormData;
  effectiveStartDate: string;
  isBillable: boolean;
}

/**
 * Schedules a time-off type policy change effective on the selected (future) date.
 * Endpoint: PUT /api/time-off/settings/types/{typeId}.
 */
export const updateTimeOffType = async (
  id: number,
  payload: UpdateTimeOffTypePayload
): Promise<void> => {
  const endpoint = `/api/time-off/settings/types/${id}`;

  await withApiErrorHandler(endpoint, ApiErrorCode.TIME_OFF_TYPE_UPDATE_FAILED, () =>
    axiosInstance.put<ApiResponse<TimeOffPolicyResponse>>(
      endpoint,
      mapTimeOffPolicyToUpdateRequest({
        data: payload.data,
        effectiveStartDate: payload.effectiveStartDate,
        isBillable: payload.isBillable,
      })
    )
  );
};
